import axios from 'axios';
import { useInfiniteQuery } from '@tanstack/react-query';

export const usePassportRequests = (email) => {
  return useInfiniteQuery({
    queryKey: ['passportRequests'],
    queryFn: async ({ pageParam = null }) => {
      const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/passport/requests`, {
        params: {
          nextPage: pageParam,
          email: email ? encodeURIComponent(email) : null
        }
      });

      return {
        passportRequests: data?.passport_requests ?? [],
        nextPage: data?.nextPage ?? null
      };
    },
    getNextPageParam: (lastPage) => {
      return lastPage?.nextPage || null;
    }
  });
};

export const usePassportOnboardings = (email) => {
  return useInfiniteQuery({
    queryKey: ['passportOnboardings'],
    queryFn: async ({ pageParam = null }) => {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/passport/onboardings`,
        {
          params: {
            nextPage: pageParam,
            email: email ? encodeURIComponent(email) : null
          }
        }
      );

      return {
        passportRequests: data?.passport_requests ?? [],
        nextPage: data?.nextPage ?? null
      };
    },
    getNextPageParam: (lastPage) => {
      return lastPage?.nextPage || null;
    }
  });
};
